<script setup>
import { ref, defineProps } from 'vue'
import Sidebar from "./Sidebar.vue";
import MainNav from "./MainNav.vue";

const sidebarToggle = ref(false);

let title = pageTitle

</script>

<template>
    <div class="flex w-screen h-screen">
        <sidebar @hide-sidebar="sidebarToggle = false"
                 :class="sidebarToggle ? 'w-full' : 'w-0'">
        </sidebar>
        <div class="overflow-y-auto relative z-10 w-full h-full text-gray-900 sm:w-10/12 bg-gray-100">
<!--            <main-nav class="flex relative sticky top-0 z-10 justify-between items-center py-3 px-4 bg-white border-b"-->
<!--                      v-on:open-sidebar="sidebarToggle = true">-->
<!--            </main-nav>-->
            <main-nav class="flex relative sticky top-0 z-10 justify-between items-center py-3 px-4 bg-white border-b"
                      v-on:open-sidebar="sidebarToggle = true"
                      :mobile-title="title">
            </main-nav>
            <slot name="content" />
        </div>
    </div>
</template>

<style scoped>

</style>
